import { BasicButton } from 'thrive-components';
import { DeleteCommentConstants } from './DeleteComment.hooks';



const DeleteCommentButton = ({onShowDeleteFunctionalityClick}: {onShowDeleteFunctionalityClick: () => void}) => {
    const {deleteCommentButtonText, deleteCommentButtonLabel, deleteCommentButtonClassname } = DeleteCommentConstants;

    return (
        <div className={"delete-comment-panel"}>
            <BasicButton 
                className={deleteCommentButtonClassname} 
                content={deleteCommentButtonText} 
                ariaLabel={deleteCommentButtonLabel} 
                onButtonClick={onShowDeleteFunctionalityClick}
            />
        </div>
    );
};
export default DeleteCommentButton